import PrimeTransactionContainer from "./PrimeTransactionContainer";
import PrimeTransactionStore from "./PrimeTransactionStore";

export default PrimeTransactionStore(PrimeTransactionContainer);
